import { httpService } from '@/services/http.service'
import { ThemeInfo } from '@/types/http'
import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules'
import store from '../index'

@Module
class ThemeModule extends VuexModule {

  private _themeInfo: { [key: string]: any } = {}
  private _hyroxThemeInfo: { [key: string]: any } = {}
  private _velocityThemeInfo: { [key: string]: any } = {}

  get themeInfo() {
    return this._themeInfo
  }

  get hyroxThemeInfo() {
    return this._hyroxThemeInfo
  }

  get velocityThemeInfo() {
    return this._velocityThemeInfo
  }

  @Mutation
  private setThemeInfo(config: { [key: string]: any } ) {
    this._themeInfo = config
  }

  @Mutation
  private setHyroxTheme(config: { [key: string]: any } ) {
    this._hyroxThemeInfo = config
  }

  @Mutation
  private setVelocityTheme(config: { [key: string]: any }) {
    this._velocityThemeInfo = config
  }

  @Action
  async initialize() {
    this.setThemeInfo(await httpService.styles() as ThemeInfo)
    this.setVelocityTheme(await httpService.velocityStyles() as ThemeInfo)
    if (this._themeInfo.theme === 'fitness_first') {
      this.setHyroxTheme(await httpService.FFHyroxStyles() as ThemeInfo)
    } else if (this._themeInfo.theme === 'dir') {
      this.setHyroxTheme(await httpService.dirHyroxStyles() as ThemeInfo)
    } else {
      this.setHyroxTheme(await httpService.hyroxStyles() as ThemeInfo)
    }
  }
}

export const themeModule = new ThemeModule({ store, name: 'theme' })